import {
  Building2, Building, LineChart, Droplets, Wind, Leaf,
  Users, Lightbulb, Target, Handshake,
  Shield, Award, Briefcase, HardHat, Wrench, ClipboardCheck, ThermometerSun, FileCheck,
} from "lucide-react";

export const ICONS = {
  Building2, Building, LineChart, Droplets, Wind, Leaf,
  Users, Lightbulb, Target, Handshake,
  Shield, Award, Briefcase, HardHat, Wrench, ClipboardCheck, ThermometerSun, FileCheck,
};

export const Icon = ({ name, className, strokeWidth = 1.25 }) => {
  const Cmp = ICONS[name] || Building2;
  return <Cmp className={className} strokeWidth={strokeWidth} />;
};
